import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default class PrescriptionInfo extends React.Component {
    constructor(props) {
        super(props);
        this.toggleModal = this.toggleModal.bind(this);
        this.state = { showModal: false };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.PrescriptionInfo.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    toggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    render() {
        const { containerClass, rx, archiveUnarchive, userDetails } = this.props;
        const imageUrl = rx && rx.NDCImageURL ? rx.NDCImageURL : '/images/prescription_placeholder.jpg';
        return (
            <div className={"rx-info " + containerClass}>
                <div className="row">
                    <div className="col-12">
                        <div className="rx-img-container">
                            <div className="rx-img">
                                <img src={imageUrl} alt={rx.DrugName + " photo"} className="img-responsive" />
                            </div>
                        </div>
                        <div className="rx-info-container">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="h3">{rx.DrugName}</h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-6 rx-archive-info">
                                    <h3 className="h4">RX No. {rx.RxNumber}</h3>
                                    <div className="rx-refill-info">{rx.RefillsInfo ? rx.RefillsInfo : '-'}</div>
                                    {rx.IsArchived
                                        ? <div className="unarchive-rx" onClick={() => this.toggleModal()}><span className="icon-unarchive" /> Unarchive</div>
                                        : <div className={rx.CanBeArchived ? "archive-rx" : "archive-disabled"} onClick={() => { if (rx.CanBeArchived) this.toggleModal(); }}><span className="icon-archive" /> Archive</div>
                                    }
                                </div>
                                <div className="col-12 col-sm-12 col-md-6">
                                    <h4 className="h5">Next Fill:</h4> {rx.NextFillDate ? rx.NextFillDate : '-'}<br />
                                    <h4 className="h5">Last Fill:</h4> {rx.LastFillDate ? rx.LastFillDate : '-'}<br />
                                    <h4 className="h5">Date Issued:</h4> {rx.DateIssued ? rx.DateIssued : '-'}
                                </div>
                            </div>
                        </div>
                        {this.state.showModal &&
                            <Modal className="verify-modal" isOpen={this.state.showModal} toggle={this.toggleModal} centered>
                                <ModalBody>
                                    <div className="row">
                                        <div className="col-12">
                                            <p>Are you sure you want to {rx.IsArchived ? 'unarchive' : 'archive'} this prescription?</p>
                                            <div className="row link-container">
                                                <div className="col-6 link-left"><button type="button" className="btn btn-link-style" onClick={() => { archiveUnarchive(rx, userDetails); this.toggleModal(); }}>YES</button></div>
                                                <div className="col-6 link-right"><button type="button" className="btn btn-link-style" onClick={this.toggleModal}>NO</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                        }
                    </div>
                </div>
            </div>
        );
    }
}